import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-two',
  templateUrl: './blog-two.component.html',
  styleUrls: ['./blog-two.component.scss']
})
export class BlogTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
